import React from 'react'
import { Collapse, IconButton, Stack } from '@mui/material'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { formatSki } from 'src/Libs/flow/advanced-settings/utils/format-ski'
import TrustSKIPanel from 'src/Libs/installations/components/new-installation/configuration/em360/TrustSKIPanel'
import { TrustSmgwSkiForm } from 'src/Libs/installation-settings/model/smart-meter-gateway.model'
import { J2Copy } from '@e3dc-react/icons'
import { useCopyToClipboard } from 'src/Elements/CopyToClipboard/hook'

interface Props {
  isEebusEnabled: boolean
  em360EebusSki?: string
  smgSki?: string
  trustedSkis: string[]
  emcDeviceId?: string
  trustSmartMeterGatewaySki: (form: TrustSmgwSkiForm) => Promise<void | null>
  isDisabled?: boolean
  systemSkiLabel: string
}

const SkiDetails: React.FC<Props> = ({
  isEebusEnabled,
  em360EebusSki,
  emcDeviceId,
  smgSki,
  trustedSkis,
  trustSmartMeterGatewaySki,
  isDisabled,
  systemSkiLabel,
}) => {
  const { copyToClipboard } = useCopyToClipboard()
  const trustedSki = trustedSkis[0]

  const handleCopyToClipboard = async (): Promise<void> => {
    const value = em360EebusSki ? em360EebusSki.toString() : ''
    await copyToClipboard(value)
  }

  return (
    <Collapse in={isEebusEnabled}>
      <Stack
        gap={4}
        sx={{ border: '1px solid', borderColor: 'shades.shade03', backgroundColor: 'shades.shade04', borderRadius: 1, p: { xs: 2, md: 3 } }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
          <Typography variant={'body1'}>{systemSkiLabel}</Typography>
          <Stack direction={'row'} alignItems={'center'} gap={1}>
            <Typography variant={'body2'}>
              {em360EebusSki ? formatSki(em360EebusSki) : 'installation-configuration.em360.smg-controlbox.em360-eebus-ski-not-connected'}
            </Typography>
            <IconButton onClick={handleCopyToClipboard} disabled={!em360EebusSki?.trim()}>
              <J2Copy sx={{ color: 'primary.main' }} />
            </IconButton>
          </Stack>
        </Stack>
        <TrustSKIPanel
          smgSki={trustedSki ?? smgSki}
          isSmgwSkiTrusted={!!trustedSki}
          emcDeviceId={emcDeviceId}
          trustSmartMeterGatewaySki={trustSmartMeterGatewaySki}
          isDisabled={isDisabled}
        />
      </Stack>
    </Collapse>
  )
}

export default SkiDetails
